import React, { useState, useEffect } from 'react';
import { Select, useToast } from '@morressier/alembic';
import { IJournalMember } from '@publishing-engine/domain/models';
import { UseMutationResult } from '@tanstack/react-query';

interface RoleSelectProps {
  member: IJournalMember;
  roles: string[];
  isDisabled?: boolean;
  updateMembershipMutation: UseMutationResult<
    (string[] & { isSuccess: true }) | { message: any; isSuccess: false },
    unknown,
    IJournalMember,
    unknown
  >;
}

const SelectMember: React.FC<RoleSelectProps> = ({
  member,
  roles,
  isDisabled,
  updateMembershipMutation
}) => {
  const [role, setRole] = useState(member?.roleName);
  const toast = useToast();

  useEffect(() => {
    setRole(member?.roleName);
  }, [member?.roleName]);

  const onUpdateMembership = async (updatedMember: IJournalMember) => {
    try {
      const res = await updateMembershipMutation?.mutateAsync(updatedMember);

      if (res.isSuccess) {
        setRole(updatedMember?.roleName);
        return toast({
          variant: 'success',
          title: 'Member Assignment Updated',
          isClosable: true
        });
      }
      return toast({
        variant: 'error',
        title: res?.message,
        isClosable: true
      });
    } catch (error: any) {
      return toast({
        variant: 'error',
        title: error?.message || 'Something went wrong',
        isClosable: true
      });
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newRole = e.target.value;
    onUpdateMembership({
      ...member,
      roleName: newRole,
      assignmentId: member?.id
    });
  };

  return (
    <Select
      width="100%"
      value={role}
      onChange={handleChange}
      disabled={isDisabled}
    >
      {roles.map(roleName => (
        <option key={roleName} value={roleName}>
          {roleName}
        </option>
      ))}
    </Select>
  );
};

export default SelectMember;
